import commonMutations from '@/store/ui/common/mutations'

export default commonMutations
